import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from 'tyan/public/hooks'
import { hasChangedValues, getFormValue, changeItemsValue, getChangedFieldsets } from 'tyan/public/utility'

const InspectionDeviceInfoBatch = props => {
	const { setState, me } = useInstData(props, useMemo(() => ({
		state: {
			id: props.match.params.sampleInspectionID || 0,
			items已选设备: {},
			search1: '', //设备-搜索内容
		}
	}), []))

	const { showBody: Body } = props
	const { id, items已选设备 } = me.state

	useEffect(() => {
		handleDidMount()
	}, [])

	const handleDidMount = () => {
		doGetInstrumentBatchWx()
	}

	const doGetInstrumentBatchWx = (search = '') => {
		Tyan.doPostEvent('GetInstrumentBatchWx', {
			data: { search },
			onEnd: ({ errorMessage, initValues设备信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					setState({ search1: search, initValues设备信息 })
				}
			}
		})
	}

	const handlerSave = () => {
		const listSelectedIDs = items已选设备['已选设备']
		Tyan.doPostEvent('SaveInstrumentBatchWx', {
			data: { id, listSelectedIDs },
			onEnd: ({ errorMessage, }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					window.history.back()
				}
			}
		})
	}

	const handlerClose = () => {
		window.history.back()
		//onClose()
	}

	const bChanged = (fieldset) => {
		const obj = me.state[`changedValues${fieldset}`]
		return obj && Object.keys(obj).length > 0
	}

	const handlerSelected = (objChange = null) => {
		const { changedValues常规设备, items已选设备: objSelected } = me.state
		if (objChange == null) objChange = changedValues常规设备

		const listAdded = objChange['常规设备-added'] || []
		const arrIDs = objSelected['已选设备'] || []

		listAdded.map(o => {
			if (!arrIDs.includes(o)) {
				arrIDs.push(o)
				objSelected[`已选设备[${o}].id`] = o
				objSelected[`已选设备[${o}].设备编号`] = objChange[`常规设备[${o}].设备编号`]
				objSelected[`已选设备[${o}].设备名称`] = objChange[`常规设备[${o}].设备名称`]
			}
		})
		objSelected['已选设备'] = arrIDs
		setState({ items已选设备: objSelected })
	}

	const handlerDeselected = () => {
		const { changedValues已选设备: objChange, items已选设备: objSelected } = me.state
		const listDeleteed = objChange['已选设备-added'] || []
		const arrIDs = objSelected['已选设备'] || []

		listDeleteed.map(o => {
			if (arrIDs.includes(o)) {
				arrIDs.splice(arrIDs.findIndex(p => p == o), 1)
				delete objSelected[`已选设备[${o}].id`]
				delete objSelected[`已选设备[${o}].设备编号`]
				delete objSelected[`已选设备[${o}].设备名称`]
			}
		})
		objSelected['已选设备'] = arrIDs
		setState({ items已选设备: objSelected })
	}

	const handlerSearch = (search) => {
		const { items已选设备: objSelected } = me.state
		if (search == '') {
			return objSelected
		} else {

			const listIDs = objSelected['已选设备'] || []
			const arrIDs = []
			var objNewSelected = {}

			listIDs.map(o => {
				if (objSelected[`已选设备[${o}].设备编号`].indexOf(search) > -1 || objSelected[`已选设备[${o}].设备名称`].indexOf(search) > -1) {
					arrIDs.push(o)
					objNewSelected[`已选设备[${o}].id`] = o
					objNewSelected[`已选设备[${o}].设备编号`] = objSelected[`已选设备[${o}].设备编号`]
					objNewSelected[`已选设备[${o}].设备名称`] = objSelected[`已选设备[${o}].设备名称`]
				}
			})
			objNewSelected['已选设备'] = arrIDs
			return objNewSelected
		}
	}



	const fieldset设备信息 = () => {
		const { initValues设备信息: { items常规设备 } = {}, items已选设备, 已选搜索: search = '' } = me.state
		return [
			{
				_checkgrid: '', name: '常规设备', fieldset: '常规设备', maxWidth: '100%', rowNumbers: false, minRows: 7, maxRows: 7, margin: "0px 0px 5px 10px",
				itemsValues: items常规设备, onSearch: (v) => doGetInstrumentBatchWx(v),
				ignore: items已选设备['已选设备'] || [],
				columns: [
					{ _text: '设备编号', minWidth: 50, flex: 1, },
					{ _text: '设备名称', minWidth: 50, flex: 1, },
				],
			},
			{
				_buttons: [
					{ _button: '', icon: 'angle-double-down', ui: 'action', handler: () => handlerSelected(), disabled: !bChanged('常规设备'), margin: '0px 5px 0px 0px', },
					{ _button: '', icon: 'angle-double-up', ui: 'action', handler: handlerDeselected, disabled: !bChanged('已选设备'), margin: '0px 0px 0px 5px', },
				], width: '100%', margin: '0px 0px 0px 0px', layout: { type: 'hbox', pack: 'center', align: 'middle' },
			},
			{
				_checkgrid: '', name: '已选设备', fieldset: '已选设备', maxWidth: '100%', rowNumbers: false, minRows: 7, maxRows: 7, margin: "0px 0px 5px 0px",
				itemsValues: handlerSearch(search) /* items已选设备 */, onSearch: (v) => setState({ 已选搜索: v }),
				columns: [
					{ _text: '设备编号', minWidth: 50, flex: 1, },
					{ _text: '设备名称', minWidth: 50, flex: 1, },
				],
			},
		]
	}

	return <Body data={me}
		controls={
			[
				{ _button: '确定', icon: '', handler: handlerSave, disabled: !(items已选设备['已选设备'] && items已选设备['已选设备'].length > 0), },
				{ _button: '取消', icon: '', handler: handlerClose },
			]
		}
		fieldsets={
			[
				{ title: '', name: '基本信息', _fieldset: fieldset设备信息(), fullblock: true },
			]}
	/>
}

export default InspectionDeviceInfoBatch